module.exports = __webpack_public_path__ + "bin/bd076c8fafa4212e2ca18a0d241f3ca8.png";